import SectionNav from "@/components/SectionNav";
import { prefetchCustomers } from "@/features/customers/customersQueryClient";
import { Outlet } from "react-router-dom";

function prefetchCustomersChunk() {
  void import("@/features/customers/CustomersV2Root");
}

function warmCustomers() {
  prefetchCustomersChunk();
  void prefetchCustomers();
}

const TABS = [
  { to: "/marketing", label: "Marketing", end: true },
  {
    to: "/marketing/customers",
    label: "Customers",
    end: false,
    onHover: warmCustomers,
  },
];

export default function MarketingNav() {
  return (
    <div data-testid="marketing-nav">
      <SectionNav tabs={TABS} ariaLabel="Marketing sections" testIdPrefix="marketing" />
      <Outlet />
    </div>
  );
}
